import { Button } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import { useRouter } from 'next/router';
import useAuth from '@modules/auth/hooks/api/useAuth';

interface UpgradeButtonProps {
  size?: number;
}

const UpgradeButton = ({ size = 35 }: UpgradeButtonProps) => {
  const router = useRouter();
  const { user } = useAuth();
  const hasSystemX = user?.hasActiveSx || user?.isDemo;
  const target = hasSystemX ? '/systemx' : '/pro';

  return (
    <Button
      onClick={() => router.push(target)}
      sx={{
        background: 'linear-gradient(135deg, #fde047 0%, #f59e0b 60%, #b45309 100%)',
        borderRadius: '500px',
        boxShadow: '0 4px 14px 0 rgba(245, 158, 11, 0.45), 0 0 0 1px rgba(180, 83, 9, 0.25) inset',
        padding: size * 0.025,
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        width: size,
        minWidth: size,
        height: size,
        '&:hover': {
          filter: 'brightness(1.08)',
          boxShadow: '0 6px 20px 0 rgba(245, 158, 11, 0.6), 0 0 0 1px rgba(180, 83, 9, 0.3) inset',
        },
      }}
    >
      <StarIcon sx={{ color: '#fff', filter: 'drop-shadow(0 1px 2px rgba(120, 53, 15, 0.6))' }} />
    </Button>
  );
};

export default UpgradeButton;
